// 2020-06-27export { TropaArchivoComponent } from './tropa-archivo.component';